import { render, staticRenderFns } from "./OccuranceList.vue?vue&type=template&id=66ae03eb&"
import script from "./OccuranceList.vue?vue&type=script&lang=js&"
export * from "./OccuranceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports